export function resize(
  definition,
  status,
  currentItemView,
  methods,
) {
  const resizeStatuses = ['top-left', 'top-right', 'bottom-left', 'bottom-right']
  if (!resizeStatuses.includes(status)) return false
  if (!methods.getItem) return false

  //user's end callback
  const onResize = definition.onResize
  if (onResize) onResize(methods.getItem(currentItemView))
  else return false

  //stop checking of interations
  return true
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseUp/resize.js